'use strict';

exports.__esModule = true;

exports['default'] = function (oldVnode, vnode) {
  if (window.asmDom.unsafePatch === false && window.asmDomHelpers.currentNode !== oldVnode && window.asmDomHelpers.currentNode !== undefined) return;
  // eslint-disable-next-line
  if (oldVnode === vnode) return vnode;
  window.asmDomHelpers.currentNode = vnode;
  if (typeof oldVnode !== 'number') {
    var props = new window.asmDom.MapStringString();
    if (oldVnode.id !== '') props.set('id', oldVnode.id);
    if (oldVnode.className !== '') props.set('class', oldVnode.className);
    oldVnode = window.asmDom._h_elm(oldVnode.tagName.toLowerCase(), props, window.asmDomHelpers.domApi.addNode(oldVnode));
    props['delete']();
  }
  window.asmDom._patch(oldVnode, vnode);
  if (window.asmDom.clearMemory === true) {
    setTimeout(window.asmDom.deleteVNode.bind(null, oldVnode));
  }
  // eslint-disable-next-line
  return vnode;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/asm-dom/lib/js/patch.js
// module id = 5
// module chunks = 2